import { render, staticRenderFns } from "./AddOi.vue?vue&type=template&id=f8dc5924&"
import script from "./AddOi.vue?vue&type=script&lang=js&"
export * from "./AddOi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports